<template>
  <div class="field-container">
    <label :for="id" class="form-label">{{ $t(`forms.${label}`) }}</label>

    <div class="row">
      <!--<input :type="type" v-bind:value="value" @input="$emit('input', $event.target.value)" :id="id" class="form-input"/>-->
      <datepicker
        :value="value"
        @input="onBirthday"
        class="form-input"
        input-class="datepicker-input"
        :language="fr"
      ></datepicker>

      <div class="valid-field">
        <img v-if="isValid" src="@/assets/input-valid-check-mark.png" />
        <span v-else></span>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import format from 'date-fns/format'
import { fr } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'VvFormBirthdayInput',
  components: {
    Datepicker
  },
  data: () => ({
    fr: fr
  }),
  computed: {
    isValid() {
      if (this.valid === null) {
        return this.value !== '' && this.value !== null
      } else {
        return this.valid
      }
    }
  },
  props: {
    id: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    },
    valid: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    onBirthday(date) {
      this.birthday = date
      const birthdayString = format(date, 'yyyy/MM/dd')

      this.$emit('input', birthdayString)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.form-input {
  height: 14px;
  border-radius: 5px;
  background-color: #f6f6f6;
  padding: 9px 13px 9px 13px;
  font-family: Avenir;
  font-size: 10.8px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  width: 74%;
  color: $font-color;
  border: none;
}

.form-label {
  text-align: left;
  margin-bottom: 6px;
}

.valid-field {
  float: right;
  height: 14px;
  object-fit: contain;
  padding: 10px 10px 10px 10px;
}

.row {
  display: flex;
  justify-content: space-between;
}

.field-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.datepicker-input {
  width: 100%;
}
</style>
